const AUDIENCE = [
  { title: "Coaches & Clinicians", body: "Who need a durable evidence chain beneath their programming and patient guidance, not isolated tips." },
  { title: "Operators & Athletes", body: "Who want to understand the mechanism behind every rep, not just follow a plan handed to them." },
  { title: "Curious Generalists", body: "Who want one coherent model for human physical capability, built from the ground up." },
];

export function TMSAudience() {
  return (
    <section data-testid="tms-audience-section" className="max-w-[1300px] mx-auto px-6 md:px-12 py-20 md:py-28">
      <p className="text-xs uppercase tracking-[0.3em] text-[#5e1420] mb-10">Who This Is For</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {AUDIENCE.map((a) => (
          <div key={a.title} data-testid={`tms-audience-${a.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="border border-border p-7 bg-card">
            <h3 className="text-base font-subtitle mb-3">{a.title}</h3>
            <p className="text-textSecondary text-sm leading-[1.7]">{a.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
